import { render, staticRenderFns } from "./usergroup.vue?vue&type=template&id=463b1b5a&lang=pug"
import script from "./usergroup.vue?vue&type=script&lang=js"
export * from "./usergroup.vue?vue&type=script&lang=js"
import style0 from "./usergroup.vue?vue&type=style&index=0&id=463b1b5a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports